export type AuthStatusTone = "success" | "danger" | "neutral" | "info";

export interface AuthTrackingStat {
  id: string;
  title: string;
  value: string;
  icon: string;
}

export interface AuthAuditEvent {
  id: string;
  title: string;
  status: string;
  statusTone: AuthStatusTone;
  description: string;
}

export interface AuthCptCode {
  id: string;
  code: string;
  description: string;
}

export interface AuthTrackingRecord {
  id: string;
  claimId: string;
  priorAuthNumber: string;
  service: string;
  memberPlan: string;
  payer: string;
  submission: string;
  submissionTone: AuthStatusTone;
  authStatus: string;
  authStatusTone: AuthStatusTone;
  delivery: string;
  deliveryTone: AuthStatusTone;
  http: number;
  attempts: number;
  submittedDate: string;
  submittedTime: string;
  receivedDate: string;
  receivedTime: string;
  ehrOrganization: string;
  endpoint: string;
  subscription: string;
  decisionDate: string;
  decisionTime: string;
  requestStatus: string;
  requestStatusTone: AuthStatusTone;
  cptCodes: AuthCptCode[];
  auditTrail: AuthAuditEvent[];
}

export const AUTH_TRACKING_STATS: AuthTrackingStat[] = [
  {
    id: "requests",
    title: "Prior Auth Request",
    value: "2",
    icon: "fh_select_mem_2",
  },
  {
    id: "approved",
    title: "Approved",
    value: "1",
    icon: "fh_check_circle_fill",
  },
  {
    id: "denied",
    title: "Denied",
    value: "1",
    icon: "fh_rejection",
  },
  {
    id: "notify",
    title: "Notify",
    value: "2/0",
    icon: "fh_bell_fill",
  },
];

export const AUTH_TRACKING_ROWS: AuthTrackingRecord[] = [
  {
    id: "1",
    claimId: "claim-0a5399e6-302e-44ac-88a7-90c0340365cb",
    priorAuthNumber: "PA-2026-0810-1412",
    service: "MRI brain w/o contrast",
    memberPlan: "Member - Commercial HMO",
    payer: "Carelon",
    submission: "Completed",
    submissionTone: "success",
    authStatus: "Approved",
    authStatusTone: "success",
    delivery: "Success",
    deliveryTone: "success",
    http: 200,
    attempts: 1,
    submittedDate: "08/10/2026",
    submittedTime: "14:12",
    receivedDate: "08/10/2026",
    receivedTime: "14:12",
    ehrOrganization: "AaNeelConnectFhirAdmin",
    endpoint: "EHR notification listener",
    subscription: "1825d37sfd746435373e4k8ec",
    decisionDate: "08/10/2026",
    decisionTime: "14:13",
    requestStatus: "Complete",
    requestStatusTone: "success",
    cptCodes: [
      { id: "1-1", code: "70551", description: "MRI brain w/o contrast" },
      { id: "1-2", code: "70553", description: "MRI brain w/o & w/ contrast" },
      { id: "1-3", code: "70450", description: "CT head/brain w/o contrast" },
      { id: "1-4", code: "70460", description: "CT head/brain w/ contrast" },
      { id: "1-5", code: "72141", description: "MRI cervical spine w/o contrast" },
      { id: "1-6", code: "72148", description: "MRI lumbar spine w/o contrast" },
      { id: "1-7", code: "73721", description: "MRI joint of lower extremity" },
    ],
    auditTrail: [
      {
        id: "sub-ready",
        title: "Provider subscription ready",
        status: "Success",
        statusTone: "success",
        description: "EHR Registered for prior auth-status updates",
      },
      {
        id: "submitted",
        title: "Provider auth submitted",
        status: "Success",
        statusTone: "success",
        description: "Ordering provider sent request from the EHR",
      },
      {
        id: "routed",
        title: "Routed to health plan",
        status: "Success",
        statusTone: "success",
        description: "Carelon received the authorization request",
      },
      {
        id: "decision",
        title: "Coverage decision recorded",
        status: "Success",
        statusTone: "success",
        description: "prior authorization Approved for request service",
      },
      {
        id: "notify",
        title: "Notification delivery",
        status: "Success",
        statusTone: "success",
        description:
          "Delivery status Success · rest-hook reached the EHR · 1 attempt",
      },
    ],
  },
  {
    id: "2",
    claimId: "claim-1b82c4d9-9e11-62a7-b3f1-81d0451476dc",
    priorAuthNumber: "PA-2026-0810-1348",
    service: "CT abdomen w/ contrast",
    memberPlan: "Member - Medicare Advantage",
    payer: "HealthAxis",
    submission: "Completed",
    submissionTone: "success",
    authStatus: "Denied",
    authStatusTone: "danger",
    delivery: "Success",
    deliveryTone: "success",
    http: 200,
    attempts: 1,
    submittedDate: "08/10/2026",
    submittedTime: "13:48",
    receivedDate: "08/10/2026",
    receivedTime: "13:49",
    ehrOrganization: "AaNeelConnectFhirAdmin",
    endpoint: "EHR notification listener",
    subscription: "2916e48tge857546484f5l9fd",
    decisionDate: "08/10/2026",
    decisionTime: "13:51",
    requestStatus: "Complete",
    requestStatusTone: "success",
    cptCodes: [
      { id: "2-1", code: "74177", description: "CT abdomen & pelvis w/ contrast" },
      { id: "2-2", code: "74160", description: "CT abdomen w/ contrast" },
      { id: "2-3", code: "74170", description: "CT abdomen w/o & w/ contrast" },
      { id: "2-4", code: "71260", description: "CT thorax w/ contrast" },
      { id: "2-5", code: "72193", description: "CT pelvis w/ contrast" },
      { id: "2-6", code: "76700", description: "Ultrasound abdominal complete" },
    ],
    auditTrail: [
      {
        id: "sub-ready",
        title: "Provider subscription ready",
        status: "Success",
        statusTone: "success",
        description: "EHR Registered for prior auth-status updates",
      },
      {
        id: "submitted",
        title: "Provider auth submitted",
        status: "Success",
        statusTone: "success",
        description: "Ordering provider sent request from the EHR",
      },
      {
        id: "routed",
        title: "Routed to health plan",
        status: "Success",
        statusTone: "success",
        description: "HealthAxis received the authorization request",
      },
      {
        id: "decision",
        title: "Coverage decision recorded",
        status: "Success",
        statusTone: "success",
        description: "prior authorization Denied for request service",
      },
      {
        id: "notify",
        title: "Notification delivery",
        status: "Success",
        statusTone: "success",
        description:
          "Delivery status Success · rest-hook reached the EHR · 1 attempt",
      },
    ],
  },
];
